import React from 'react';

import { Star as StarIcon } from '@mui/icons-material';
import { Box, ButtonProps, Typography } from '@mui/material';

import { Button } from 'src/components/common';

export const ButtonSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Button</Typography>

      <Box mt={2}>
        {buttonSizes.map((buttonSize, index) => (
          <Box key={buttonSize} mt={index > 0 ? 4 : 0}>
            <Box>{renderButtons(buttonSize, false)}</Box>
            <Box mt={2}>{renderButtons(buttonSize, true)}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const renderButtons = (buttonSize: ButtonSize, disabled: boolean) => {
  return (
    <React.Fragment>
      {buttonVariants.map((buttonVariant, index) => (
        <Box key={buttonVariant} display="flex" gap={2} mt={index > 0 ? 2 : 0}>
          {buttonColors.map(buttonColor => (
            <Box key={buttonColor}>
              <Button
                size={buttonSize}
                variant={buttonVariant}
                color={buttonColor}
                startIcon={buttonVariant === 'text' && <StarIcon />}
                disabled={disabled}
              >
                {buttonSize} {buttonVariant} {buttonColor}
              </Button>
            </Box>
          ))}
        </Box>
      ))}
    </React.Fragment>
  );
};

type ButtonSize = NonNullable<ButtonProps['size']>;
const buttonSizes: ButtonSize[] = ['large', 'medium', 'small'];

type ButtonVariant = NonNullable<ButtonProps['variant']>;
const buttonVariants: ButtonVariant[] = ['contained', 'outlined', 'text'];

type ButtonColor = NonNullable<ButtonProps['color']>;
const buttonColors: ButtonColor[] = ['primary', 'secondary', 'error'];
